import { ArrowRight } from "lucide-react";
import { Field, PrivacyNote } from "./FormPrimitives";

// Step 1: contact details (name / mobile / email).
export const StepOne = ({ form, errors, onField, onFocus, onNext }) => (
  <div data-testid="registration-step-1" className="space-y-4">
    <Field label="Full Name" error={errors.full_name}>
      <input
        data-testid="input-full-name"
        type="text"
        autoComplete="name"
        value={form.full_name}
        onFocus={onFocus}
        onChange={(e) => onField("full_name", e.target.value)}
        placeholder="e.g. Tan Wei Ming"
        className="reg-input"
      />
    </Field>

    <Field label="Mobile Number" error={errors.mobile}>
      <div className="flex">
        <span className="inline-flex items-center px-3 rounded-l-xl border border-r-0 border-[rgba(17,42,67,0.18)] bg-[#FBF8F0] text-[#122131] font-medium">+65</span>
        <input
          data-testid="input-mobile"
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          maxLength={9}
          value={form.mobile}
          onFocus={onFocus}
          onChange={(e) => onField("mobile", e.target.value.replace(/[^\d ]/g, ""))}
          placeholder="8123 4567"
          className="reg-input rounded-l-none"
        />
      </div>
    </Field>

    <Field label="Email Address" error={errors.email}>
      <input
        data-testid="input-email"
        type="email"
        autoComplete="email"
        value={form.email}
        onFocus={onFocus}
        onChange={(e) => onField("email", e.target.value)}
        placeholder="you@example.com"
        className="reg-input"
      />
    </Field>

    <button
      data-testid="registration-next-button"
      onClick={onNext}
      className="w-full h-13 mt-2 inline-flex items-center justify-center gap-2 h-14 rounded-xl bg-[#F7B838] text-[#071524] font-semibold hover:bg-[#FFD16F] transition-colors active:scale-[0.99]"
    >
      Continue <ArrowRight size={18} />
    </button>
    <PrivacyNote />
  </div>
);
